/**
 * Runtime env config from window.MLBBest.envVariables (set by env-*.tsx entry chunk).
 * Aligns with blue-ui: one build, multiple index-<env>.html; host serves the correct one.
 */
const raw =
  typeof window !== "undefined" && (window as any).MLBBest && (window as any).MLBBest.envVariables
    ? (window as any).MLBBest.envVariables
    : {};

export const ENV = (raw.ENV as string) || "dev";
export const SERVICES_URL = (raw.SERVICES_URL as string) || "";
export const OKTA_CLIENT_ID = (raw.OKTA_CLIENT_ID as string) || "";
export const OKTA_ISSUER = (raw.OKTA_ISSUER as string) || "";
export const OKTA_REDIRECT_URI = (raw.OKTA_REDIRECT_URI as string) || "";
export const OKTA_TESTING_DISABLEHTTPSCHECK = raw.OKTA_TESTING_DISABLEHTTPSCHECK === true;
export const DATADOG_APPLICATION_ID = (raw.DATADOG_APPLICATION_ID as string) || "";
export const DATADOG_CLIENT_TOKEN = (raw.DATADOG_CLIENT_TOKEN as string) || "";
